import { useMemo } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { HeartHandshake } from "lucide-react";
import { PALETTE, fmt, fmtMoney, KPI } from "./_shared";

export function PeopleTab({ overview, rows }) {
  const monthly = useMemo(() => {
    const m = {};
    for (const r of rows) {
      const key = r.period_month;
      const b = m[key] || (m[key] = { period_month: key, community_hours: 0, donations: 0 });
      b.community_hours += r.community_hours || 0;
      b.donations += r.donations_amount || 0;
    }
    return Object.values(m).sort((a, b) => a.period_month.localeCompare(b.period_month))
      .map((x) => ({ ...x, label: x.period_month.slice(5) }));
  }, [rows]);
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <KPI label="Community Hours"     value={fmt(overview.people.community_hours)} icon={HeartHandshake} tone="good" />
        <KPI label="Donations"           value={fmtMoney(overview.people.donations_amount)} tone="good" />
        <KPI label="Apprentices (live from HR)" value={fmt(overview.people.apprentices_count)} tone="brand" />
        <KPI label="Records (FY)"        value={fmt(rows.length)} />
      </div>
      {rows.length === 0 && (
        <div className="rounded-lg border border-slate-200 bg-white px-4 py-6 text-sm text-slate-500 text-center" data-testid="people-empty">
          No community engagement records yet — hours and donations appear here as they are logged.
          The apprentice count above is live from the HR employee register.
        </div>
      )}
      <div className="rounded-lg border border-slate-200 bg-white p-4">
        <div className="text-sm font-medium text-slate-800 mb-2">Community Engagement — Monthly</div>
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={monthly}>
            <CartesianGrid strokeDasharray="3 3" stroke="#F1F5F9" />
            <XAxis dataKey="label" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} />
            <Tooltip contentStyle={{ fontSize: "12px" }} />
            <Legend wrapperStyle={{ fontSize: "11px" }} />
            <Bar dataKey="community_hours" name="Community Hours" fill={PALETTE.emerald} radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
